export default {
	//@ts-ignore
	install(Vue, domtoimage) {
		Vue.mixin({
			methods: {
				//@ts-ignore
				async ExportById(filename, id) {
					try {
						//var dataUrl = await domtoimage.toPng(document.getElementById(id));
						//var link = document.createElement('a');
						//link.download = filename + ".png";
						//link.href = dataUrl;
						//link.click();
						//return Promise.resolve();

						//@ts-ignore
						var dataUrl = await this.$html2canvas(document.getElementById(id), { type: 'dataURL' });
						var link = document.createElement('a');
						link.download = filename + ".png";
						link.href = dataUrl;
						link.click();
						return Promise.resolve();
					}
					catch (err) {
						console.error(err);
						return Promise.reject();
					}
				},
				//@ts-ignore
				Export(id) {
					return this.ExportById(id, id);
				}
			},
			mounted() {
				Vue.prototype.$export = this.Export
				Vue.prototype.$exportWithFilename = this.ExportById
			}
		});
	}
}
